import React from "react";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "We replaced four separate tools with CRM AI. Our first-response time went from 42 minutes to under 10 seconds — on WhatsApp alone we saved 3 full-time seats.",
    author: "Anika Raj",
    role: "VP Customer Experience · Lenskraft",
    img: "https://images.unsplash.com/photo-1768247695726-022586dea3a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBhdmF0YXIlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NzY5ODUyNzB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "The flow builder is genuinely what we'd have built in-house — if we had 18 months. Our agents now resolve refunds, check inventory, and escalate edge-cases without human input.",
    author: "Jordan Blake",
    role: "Head of Ops · Northwind",
    img: "https://images.unsplash.com/photo-1644268756918-16348d1bc619?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBhdmF0YXIlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NzY5ODUyNzB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "What sold us was replay. Every conversation is debuggable — we can see the exact KB chunk the agent pulled, then iterate. It's the first AI product I've trusted in production.",
    author: "Helena Morgan",
    role: "CTO · Finchly Bank",
    img: "https://images.unsplash.com/photo-1609371497456-3a55a205d5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBhdmF0YXIlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NzY5ODUyNzB8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      id="customers"
      data-testid="testimonials-section"
      className="relative py-28 md:py-40 border-t border-white/5 overflow-hidden"
    >
      <div className="pointer-events-none absolute top-40 right-0 w-[520px] h-[420px] glow-teal opacity-25" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-6">
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-white max-w-2xl">
            Trusted by teams moving
            <br />
            <span className="italic text-white/80">millions of conversations.</span>
          </h2>
          <div className="flex gap-10 text-white/50 text-[13px] font-mono uppercase tracking-[0.12em]">
            <div>
              <div className="font-serif text-4xl text-white not-italic">
                2.4M+
              </div>
              <div className="mt-1">Conversations / month</div>
            </div>
            <div>
              <div className="font-serif text-4xl text-white">63</div>
              <div className="mt-1">Countries live</div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="card-surface p-8 flex flex-col justify-between min-h-[360px]"
            >
              <Quote className="w-6 h-6 text-[#7C5CFF] opacity-60 mb-6" />
              <blockquote className="font-serif text-[22px] leading-[1.3] text-white/90 italic">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3 pt-6 border-t border-white/5">
                <img
                  src={t.img}
                  alt={t.author}
                  className="w-10 h-10 rounded-full object-cover grayscale"
                />
                <div>
                  <div className="text-[13px] font-medium text-white">
                    {t.author}
                  </div>
                  <div className="text-[11px] text-white/45">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
